(function () {
  if (typeof window === 'undefined') return;

  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '{{amount}} zł';

  function formatMoney(cents) {
    var value = cents / 100;
    var str = value.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(moneyFormat)) {
      return moneyFormat.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, str);
    }
    if (/\{\{\s*amount\s*\}\}/.test(moneyFormat)) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, str);
    }
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(moneyFormat)) {
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toString());
    }
    return str + ' zł';
  }

  function parseVariants(root) {
    try {
      var script = root.querySelector('[data-bundle-variants]');
      return script ? JSON.parse(script.textContent) : [];
    } catch (e) {
      return [];
    }
  }

  function findVariant(variants, id) {
    return variants.find(function (v) {
      return v.id === id;
    });
  }

  function getCardPricing(label, variant, variants) {
    var price = variant ? variant.price : parseInt(label.getAttribute('data-variant-price'), 10);
    var compare = variant ? variant.compare_at_price : parseInt(label.getAttribute('data-variant-compare'), 10);

    if ((!compare || compare <= price) && variant) {
      var ref = variants[0];
      if (ref && ref.compare_at_price && ref.compare_at_price > ref.price && ref.price > 0) {
        compare = Math.round((price * ref.compare_at_price) / ref.price);
      }
    }

    if (!price) {
      price = parseInt(label.getAttribute('data-variant-price'), 10);
    }
    if (!compare || compare <= price) {
      compare = parseInt(label.getAttribute('data-variant-compare'), 10);
    }

    return {
      price: price || 0,
      compare: compare && compare > price ? compare : 0,
    };
  }

  function setActiveCard(root, variantId) {
    root.querySelectorAll('[data-bundle-variant]').forEach(function (label) {
      var id = parseInt(label.getAttribute('data-variant-id'), 10);
      var isActive = id === variantId;
      label.classList.toggle('is-active', isActive);
      var input = label.querySelector('input');
      if (input) input.checked = isActive;
    });
  }

  function syncBundleCardPricing(root, variants) {
    root.querySelectorAll('[data-bundle-variant]').forEach(function (label) {
      var variantId = parseInt(label.getAttribute('data-variant-id'), 10);
      var variant = findVariant(variants, variantId);
      var pricing = getCardPricing(label, variant, variants);

      var priceEl = label.querySelector('[data-bundle-price]');
      var compareEl = label.querySelector('[data-bundle-compare]');

      if (priceEl) priceEl.textContent = formatMoney(pricing.price);

      if (compareEl) {
        if (pricing.compare > pricing.price) {
          compareEl.hidden = false;
          compareEl.innerHTML = '<s>' + formatMoney(pricing.compare) + '</s>';
        } else {
          compareEl.hidden = true;
          compareEl.innerHTML = '';
        }
      }
    });
  }

  function replaceBundlePicker(productInfo, source) {
    var sourcePicker = source.querySelector('[data-bundle-picker]');
    var destPicker = productInfo.querySelector('[data-bundle-picker]');
    if (!sourcePicker || !destPicker) return destPicker;

    var clone = sourcePicker.cloneNode(true);
    destPicker.replaceWith(clone);
    initBundlePicker(clone);
    return clone;
  }

  function updateProductInfo(root, productInfo, sectionId, variantId, productUrl) {
    fetch(productUrl + '?variant=' + variantId + '&section_id=' + sectionId)
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var source = html.querySelector('product-info');
        if (!source) return;

        ['price', 'Sku', 'Inventory', 'Volume', 'Price-Per-Item'].forEach(function (id) {
          var destination = productInfo.querySelector('#' + id + '-' + sectionId);
          var sourceEl = source.querySelector('#' + id + '-' + sectionId);
          if (destination && sourceEl) destination.innerHTML = sourceEl.innerHTML;
        });

        var sourceBtn = html.getElementById('ProductSubmitButton-' + sectionId);
        var destBtn = document.getElementById('ProductSubmitButton-' + sectionId);
        if (sourceBtn && destBtn) {
          if (sourceBtn.hasAttribute('disabled')) destBtn.setAttribute('disabled', 'disabled');
          else destBtn.removeAttribute('disabled');
          var sourceText = sourceBtn.querySelector('span');
          var destText = destBtn.querySelector('span');
          if (sourceText && destText) destText.textContent = sourceText.textContent;
        }

        productInfo.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (productInfo.dataset.updateUrl !== 'false') {
          window.history.replaceState({}, '', productUrl + '?variant=' + variantId);
        }

        root = replaceBundlePicker(productInfo, source) || root;
        setActiveCard(root, variantId);

        var variant = findVariant(variants, variantId);

        if (variant && variant.featured_media && variant.featured_media.id) {
          var gallery = productInfo.querySelector('media-gallery');
          if (gallery && typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(gallery.id + '-' + variant.featured_media.id, true);
          }
        }

        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: sectionId,
              html: html,
              variant: variant,
            },
          });
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function initBundlePicker(root) {
    var sectionId = root.getAttribute('data-section-id');
    var productInfo = document.querySelector('product-info');
    if (!productInfo || !sectionId) return;

    var productUrl = productInfo.dataset.url;

    root.querySelectorAll('[data-bundle-variant]').forEach(function (label) {
      label.addEventListener('click', function () {
        if (label.classList.contains('is-unavailable')) return;
        var variantId = parseInt(label.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        setActiveCard(root, variantId);
        updateProductInfo(root, productInfo, sectionId, variantId, productUrl);
      });
    });

    var params = new URLSearchParams(window.location.search);
    var urlVariantId = parseInt(params.get('variant'), 10);
    var variants = parseVariants(root);
    if (urlVariantId && findVariant(variants, urlVariantId)) {
      setActiveCard(root, urlVariantId);
    }
  }

  document.querySelectorAll('[data-bundle-picker]').forEach(initBundlePicker);
})();
